// extracted by mini-css-extract-plugin
export default {"file":"uploaded-archive_file__Gj+wG","row":"uploaded-archive_row__Pn9Cx"};